// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bj_s"};